import React from 'react';
import PropTypes from 'prop-types';

import ReportDetails from './ReportDetails';
import { REPORT_TYPE_DISRUPTIVE } from '../ReservationFeedbackModalV2.constants';
import messages from '../ReservationFeedbackModalV2.messages';

const DisruptiveUserReportDetails = ({
  fullName,
  profileUrl,
  venueId,
  reservationId,
  guidelines,
  disruptiveReasons,
  submitReport,
  onReported,
  setProcessingStep,
  setSuccessStep,
  resizeModal,
  failedFormValues,
  onSubmitError,
}) => (
  <ReportDetails
    fullName={fullName}
    profileUrl={profileUrl}
    reasonType={messages.disruptiveUser}
    guidelines={guidelines}
    venueId={venueId}
    reservationId={reservationId}
    disruptiveReasons={disruptiveReasons}
    submitReport={submitReport}
    onReported={onReported}
    reportType={REPORT_TYPE_DISRUPTIVE}
    setProcessingStep={setProcessingStep}
    setSuccessStep={setSuccessStep}
    resizeModal={resizeModal}
    failedFormValues={failedFormValues}
    onSubmitError={onSubmitError}
  />
);

DisruptiveUserReportDetails.propTypes = {
  fullName: PropTypes.string,
  profileUrl: PropTypes.string,
  venueId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  guidelines: ReportDetails.propTypes.guidelines,
  disruptiveReasons: ReportDetails.propTypes.disruptiveReasons.isRequired,
  submitReport: PropTypes.func.isRequired,
  onReported: PropTypes.func,
  resizeModal: PropTypes.func,
  setProcessingStep: PropTypes.func.isRequired,
  setSuccessStep: PropTypes.func.isRequired,
  failedFormValues: ReportDetails.propTypes.failedFormValues,
  onSubmitError: PropTypes.func,
};

export default DisruptiveUserReportDetails;
